import React, { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import Header from '../components/common/Header';
import Footer from '../components/common/Footer';
import { CheckCircle, Package, ArrowRight, ShoppingBag } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Skeleton } from '../components/ui/skeleton';

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export default function BoutiqueSuccesPage() {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const orderId = searchParams.get('order_id');
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!sessionId) { setLoading(false); return; }
    const check = async () => {
      try {
        const res = await fetch(`${BACKEND}/api/boutique/commande/status/${sessionId}`);
        const data = await res.json();
        if (data.order) setOrder(data.order);
      } catch (err) { /* silent */ }
      setLoading(false);
    };
    check();
  }, [sessionId]);

  return (
    <div style={{ background: 'var(--bg)', minHeight: '100vh' }}>
      <Header />
      <div className="container-ose section-py max-w-lg mx-auto text-center">
        {loading ? (
          <div className="space-y-4">
            <Skeleton className="h-20 w-20 rounded-full mx-auto" />
            <Skeleton className="h-8 w-3/4 mx-auto" />
            <Skeleton className="h-4 w-full" />
          </div>
        ) : (
          <>
            {/* Icône succès */}
            <div className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6"
              style={{ background: 'rgba(31,157,122,0.1)', border: '2px solid #1F9D7A' }}>
              <CheckCircle size={40} style={{ color: '#1F9D7A' }} />
            </div>

            <h1 className="font-display text-3xl font-bold mb-2" style={{ color: 'var(--ink)', letterSpacing: '-0.02em' }}>
              Commande confirmée !
            </h1>
            <p className="text-sm mb-8" style={{ color: 'var(--text-muted)' }}>
              Votre paiement a bien été reçu. Vous recevrez une confirmation par email.
            </p>

            {/* Récapitulatif commande */}
            {order && (
              <div className="p-5 rounded-2xl mb-8 text-left" style={{ background: '#fff', border: '1px solid var(--border)' }}>
                <div className="flex items-center gap-2 mb-4">
                  <Package size={18} style={{ color: 'var(--teal)' }} />
                  <p className="font-semibold" style={{ color: 'var(--ink)' }}>Commande {order.numero}</p>
                </div>
                <div className="space-y-2 mb-4">
                  {(order.items || []).map((item, i) => (
                    <div key={i} className="flex justify-between text-sm">
                      <span style={{ color: 'var(--ink)' }}>{item.nom} × {item.quantite}</span>
                      <span className="font-semibold price-gold">{item.sous_total?.toFixed(2)}€</span>
                    </div>
                  ))}
                </div>
                <div className="flex justify-between font-bold pt-3" style={{ borderTop: '1px solid var(--border)' }}>
                  <span style={{ color: 'var(--ink)' }}>Total</span>
                  <span className="price-gold text-lg">{order.total?.toFixed(2)}€</span>
                </div>
              </div>
            )}

            <div className="flex flex-col sm:flex-row gap-3">
              <Button asChild className="flex-1" style={{ background: 'var(--teal)', color: '#fff' }}>
                <Link to="/boutique">
                  <ShoppingBag size={16} className="mr-2" /> Continuer mes achats
                </Link>
              </Button>
              <Button asChild variant="outline" className="flex-1">
                <Link to="/mon-compte">
                  Mon compte <ArrowRight size={16} className="ml-2" />
                </Link>
              </Button>
            </div>
          </>
        )}
      </div>
      <Footer />
    </div>
  );
}
